import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import './AddSensor.css';
import AddSensorForm from './components/AddSensorForm';
import IState from '../../core/models/IState';
import * as actions from '../../core/actions/actions';
import { reset } from 'redux-form';
import { formatMessage } from '../../translations/connectedIntlProvider';
import { allUserSensorSelector, getSensorSelector } from '../../core/selectors/sensor.selector';
import modelEnum from '../../constants/model.enum';
import { sensorTypeOptions } from '../../constants/option.constant';

const AddSensor = (props: any) => {

  const { addSensor, sensor }: any = useSelector((state: IState) => { return state.sensor });
  const allUsersData: any = useSelector(allUserSensorSelector);
  const initialValues: any = useSelector(getSensorSelector);

  const dispatch = useDispatch();

  const QRCodeInitialData ={
    ICCID: '',
    CustomerID: "",
    Building: '',
    Floor: '',
    Room: '',
    Location: '',
    User: '',
    Comments: '',
    UserId: -1,
    SendMail: false,
    SensorType: -1
}
  useEffect(() => {
    dispatch(actions.getAllUser(1, 10000,true));
    if (props.iccid !== '' && props.iccid !== undefined) {
      dispatch(actions.getSensorById(props.iccid, props.model ? props.model === modelEnum.IAQ.toLowerCase() : false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (addSensor.success) {
      if (props.id === -1)
        toast.success(formatMessage("Message_Sensor_Add_Success"));
      else
        toast.success(formatMessage("Message_Sensor_Update_Success"));
      dispatch(actions.resetAddSensorState());
      dispatch(actions.resetGetSensorByIdState());
      dispatch(reset('AddSensorForm'));
      props.modalClosed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addSensor.success]);

  useEffect(() => {
    if (addSensor.error != null)
      toast.error(formatMessage(addSensor.error));
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [addSensor.error]);

  const onSubmitForm = (values: any) => {
    let sensorType = parseInt(values.SensorType);
    if(sensorType === 0)
      dispatch(actions.addIAQSensor(props.id, values, initialValues.UserId, true));
    else
      dispatch(actions.addSensor(props.id, values, false));
  }

  const onModalClosed = () => {
    dispatch(actions.resetAddSensorState())
    dispatch(actions.resetGetSensorByIdState())
    dispatch(reset('AddSensoForm'));
    props.modalClosed();
  }

  const QrCodeSubmitHandler = (scannedICCID:string) => {
    dispatch(actions.resetGetSensorByIdState());
    if (scannedICCID !== '' && scannedICCID !== undefined) {
        QRCodeInitialData.ICCID = scannedICCID;
        dispatch(actions.setAddSensorIdByScanner(QRCodeInitialData));
    }
  } 
  return (
    <React.Fragment>
      <AddSensorForm
        initialValues={initialValues}
        id={props.id}
        isDelete={props.isDelete}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        getSensorLoading={sensor.loading}
        addSensorLoading={addSensor.loading}
        userList={allUsersData}
        sensorTypeList={sensorTypeOptions}
        QrCodeSubmitHandler={QrCodeSubmitHandler}
      />
    </React.Fragment>
  );
};

export default AddSensor;
